import { ETypeChamp } from './typeChamp';
import { SearchFilter } from '../../shared/classes/search-filter';

export interface Searchable {
    searchFilterConfiguration: ISearchFilterConfiguration;

    // getSearchFilterConfiguration: () => ISearchFilterConfiguration;
    // getSearchFilter: () => SearchFilter;
    // getFormattedInputData: (langueId: string) => any;
}

export interface ISearchFilterConfiguration {
    searchFilter: SearchFilter;
    code: string;
    type: string;
}

export class SearchFilterConfiguration implements ISearchFilterConfiguration {

    code: string;
    type: string;
    isZ16Pro?: boolean;

    searchFilter: SearchFilter;

    constructor(code: string, type: string, isZ16Pro: boolean = false) {
        this.code = code;
        this.type = type;
        this.isZ16Pro = isZ16Pro;

        this.initializeConfig();
    }

    initializeConfig() {
        let compare = '';

        switch (this.type) {
            case ETypeChamp.TEXT:
            case ETypeChamp.TEXTAREA:
                compare = 'LIKE';
                break;

            case ETypeChamp.SELECT:
            case ETypeChamp.RADIO:
            case ETypeChamp.CHECKBOX:
                compare = '=';
                break;

            default:
                compare = '=';
        }

        this.searchFilter = new SearchFilter({
            key: this.code,
            value: '',
            compare: compare,
            type: this.type,
            isZ16Pro: this.isZ16Pro
        });
    }

}
